import { render, staticRenderFns } from "./RecentItems.vue?vue&type=template&id=0a5a0922&scoped=true&"
import script from "./RecentItems.vue?vue&type=script&lang=js&"
export * from "./RecentItems.vue?vue&type=script&lang=js&"
import style0 from "./RecentItems.vue?vue&type=style&index=0&id=0a5a0922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a0922",
  null
  
)

export default component.exports